<template>
    <rkm-modal
        :loading="loading"
        @save="$refs.Form.save()"
        ref="Modal"
        title="Unidade externa"
        :buttons="['cancel', 'save']"
    >
        <Form
            @save="handleExit"
            ref="Form"
            layout="modal"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {
            this.$refs.Modal.show()
        },
        handleExit(unidade) {

            this.$emit('save', unidade)

            this.$refs.Modal.hide()
        },
    },
}
</script>